const isPublicationDate = (published: string, unpublished: string, dateOffset: number): boolean => {
  const maxDateValue = '2050-01-01T00:00:00.000Z'
  const umbracoDateStringNotSet = '0001-01-01T00:00:00.000Z'

  // if no unpublish date is set, set a distant future unpublish date instead of default umbraco string(which is in the past)
  const alwaysPublished = unpublished === umbracoDateStringNotSet ? maxDateValue : unpublished
  const dateUnpublished: number =
    parseInt((new Date(alwaysPublished).getTime() / 1000).toFixed(0)) + dateOffset // published date in seconds
  const dateNow: number = parseInt((new Date().getTime() / 1000).toFixed(0)) // now without offset
  const datePublished: number =
    parseInt((new Date(published).getTime() / 1000).toFixed(0)) + dateOffset // published date in seconds
  if (datePublished < dateNow && dateUnpublished > dateNow) {
    return true
  } else {
    return false
  }
}

export const isPublicConvertedDate = (published: string, unpublished: string) => {
  const dateOffset: number = new Date().getTimezoneOffset() * 60
  return isPublicationDate(published, unpublished, dateOffset)
}
